import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  numberWithCommas,
  RupeesToPaise,
} from "../../../../utility/commaSeperator";
import { RUPEE_SYMBOL } from "../../../../utility/Constants";
import { convertDateWithMonthName } from "../../../../utility/dateModifier";
import { PayOutHeaders } from "../../../../utility/TableHeaders";
import { CustomFilter } from "../../../components/CustomFilter";
import { CustomModal1 } from "../../../components/customModal/CustomModal";
import CustomTable from "../../../components/customTable/CustomTable";
import CustomViewModal from "../../../components/CustomViewModal";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { INTERVAL_TIME, SUCCESS } from "../../../resources/constantsManager";
import { saveAs } from "file-saver";
import { CustomButton } from "../../../components/customButton/CustomButton";
import { API_ENDPOINT } from "../../../../data/network/services/ApiEndPoint";
import secureStorage from "../../../../utility/secureStorage";
import {
  SS_INTERVAL_ID,
  SS_INTERVAL_TIME,
  SS_REF_HASH_ID,
  SS_TOKEN,
} from "../../../resources/secureStorageManager";
import {
  removeJobAction,
  scheduleJobAction,
  setIntervalId,
} from "../../../../data/redux/action/scheduleJobAction";
import { connect, useDispatch } from "react-redux";

const Data = [];

const FundTransfer = ({ seconds }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [dateRange, setDateRange] = useState("");
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [utr, setUtr] = useState("");
  const [van, setVan] = useState("");
  const [viewMoreModal, setShowViewMoreModal] = useState(false);
  const [viewMoreData, setViewMoreData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isTableDataError, setIsTableDataError] = useState(false);

  // const [intervalId, setIntervalId] = useState("");

  const dispatch = useDispatch();
  const getAllFilters = (data) => {
    setDateRange(data[0].value?.trim());
    setUtr(data[1].value?.trim());
    setVan(data[2].value?.trim());
    getVanTransactionHistoryPayOut(
      0,
      10,
      data[0].value?.trim(),
      data[1].value?.trim(),
      data[2].value?.trim()
    );
    setOffset(0);
  };

  const getVanTransactionHistoryPayOut = (page, size, dateRange, utr, van) => {
    ApiRequestPost.vanTransactionHistoryPayOut(page, size, dateRange, utr, van)
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res.data.content);
          setTotalElements(res.data.totalElements);
          setTotalPages(res.data.totalPages);
          setIsTableDataError(false);
        } else {
          setIsTableDataError(true);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsTableDataError(true);
      });
  };

  const oncClickDownloaded = (page, size, dateRange, utr, van) => {
    ApiRequestGet.payInPayutDownload(page, size, dateRange, "payOut")
      .then((res) => {
        console.log(res, "res");

        // if (res.status === SUCCESS) {
        enqueueSnackbar("downloaded successfully", {
          variant: "success",
        });
        saveAs(res, "payout.csv");
        // } else {
        //   enqueueSnackbar("Something went wrong", {
        //     variant: "error",
        //   });
        // }
      })
      .catch((err) => {
        console.log(err, "error");
        enqueueSnackbar("Something went wrong", {
          variant: "error",
        });
      });
  };

  const Filterdata = [
    {
      title: "Select Date Range",
      type: "dateRange",
      validator: "text",
      placeholder: "Select Date Range",
      key: "searchByDateRange",
      value: dateRange,
    },
    {
      title: "Search by UTR",
      type: "input",
      validator: "alphaNum",
      placeholder: "Search by UTR",
      key: "searchByDateRange",
      value: utr,
    },
    {
      title: "Search By Van",
      type: "input",
      validator: "alphaNum",
      placeholder: "Search by VAN No",
      key: "searchByDateRange",
      value: van,
    },
  ];
  useEffect(() => {
    getVanTransactionHistoryPayOut(0, 10);
  }, []);

  const onClickSchedule = () => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    let token = secureStorage.getItem(SS_TOKEN);

    setLoading(true);

    fetch(API_ENDPOINT.basePath + "client/schedule/job", {
      headers: {
        "client-hash-id": refHashId,
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
      },
    })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          enqueueSnackbar("Job scheduled successfully", {
            variant: "success",
          });
          setIntervalForJob();
        } else {
          enqueueSnackbar("Something went wrong !", {
            variant: "error",
          });
        }
        return res.json();
      })
      .then((res) => {})
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const setIntervalForJob = async () => {
    let dateInMs = new Date();

    let interval = setInterval(async () => {
      dispatch(scheduleJobAction(seconds + 1));
    }, 1000);
    secureStorage.setItem(SS_INTERVAL_TIME, dateInMs);

    dispatch(setIntervalId(interval));
    secureStorage.setItem(SS_INTERVAL_ID, interval);
    console.log(interval, "interval");
  };

  // useEffect(() => {
  // if (seconds >= INTERVAL_TIME) {
  //   dispatch(removeJobAction());
  //   clearInterval(intervalId);
  // }
  //   console.log(seconds, "seconds");
  // }, [seconds]);

  return (
    <div>
      <TopHeaderComponent
        buttonRequired
        headerName="Pay Out"
        onClickFilter={() => setOpenFilter(!openFilter)}
        onClickDownload={() => {
          oncClickDownloaded(0, totalElements, dateRange, utr, van);
        }}
        showDeveloper={
          <CustomButton
            buttonTitle={
              seconds > 0 && seconds < INTERVAL_TIME
                ? `Button will be enabled after 15 minutes from last click`
                : ""
            }
            title="Order Enquiry"
            styles={{
              border: "none",
              width: "100%",
              borderRadius: 6,
              minWidth: 150,
            }}
            onClick={() => {
              onClickSchedule();
            }}
            loading={loading}
            disabled={seconds > 0 && seconds < INTERVAL_TIME ? true : false}
          />
        }
      />
      {openFilter && (
        <div
          style={{
            width: "100%",
            borderRadius: "15px",
            display: "flex",
            alignItems: "center",
            opacity: openFilter ? 1 : 0,
            transition: "visibility 0.5s, opacity 0.5s linear",
            marginTop: "20px",
          }}
        >
          <CustomFilter
            show={openFilter}
            data={Filterdata}
            search={(data) => {
              getAllFilters(data);
            }}
            onClickClear={() => {
              setDateRange("");
            }}
            passActiveFilters={() => {}}
            showClearIcon={true}
            // passActiveFilters={(data) => {
            //   setLiveFilters(data);
            //   call();
            // }}
            onClickFilter={() => {}}
            disableDownloadIcon={data?.length === 0}
          />
        </div>
      )}
      <div style={{ marginTop: "20px" }}>
        <CustomTable
          headers={PayOutHeaders}
          data={data}
          totalElements={totalElements}
          totalPages={totalPages}
          handlePaginate={(page) => {
            setOffset(page);
            getVanTransactionHistoryPayOut(page, 10, dateRange, utr, van);
          }}
          offset={offset}
          isFilterApplied={openFilter}
          viewMore={(data) => {
            setShowViewMoreModal(true);
            setViewMoreData(data);
            console.log("cc", data);
          }}
          isTableDataError={isTableDataError}
        />
      </div>

      {viewMoreModal && (
        <CustomModal1
          open={viewMoreModal}
          onClose={() => setShowViewMoreModal(false)}
          viewMoreStyle={{
            justifyContent: "flex-end",
          }}
        >
          {" "}
          <CustomViewModal
            data={{
              "Date & Time": convertDateWithMonthName(
                new Date(viewMoreData?.createdDate)
              ),
              "UTR:": viewMoreData?.yesRefNo,
              "VAN:": viewMoreData?.beneAccountNo,
              "Transaction Type:": viewMoreData?.debit ? "Debit" : "Credit",
              "Amount:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.transferAmt)),
              "Status:": viewMoreData?.status,
              "Fees:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.commission)),
              "Tax:":
                RUPEE_SYMBOL +
                "" +
                numberWithCommas(RupeesToPaise(viewMoreData?.tax)),
              "beneficiary_account_no:": viewMoreData?.beneAccountNo,
              "beneficiary_account_ifsc:": viewMoreData?.beneAccountIfsc,
              "beneficiary_full_name:": viewMoreData?.beneFullName,
              "transfer_type:": viewMoreData?.transferType,
              // "transfer_unique_no:": viewMoreData?.transferUniqueNo,
              "transfer_timestamp:": convertDateWithMonthName(
                new Date(viewMoreData?.transferTimestamp)
              ),
              // "transfer_ccy:": viewMoreData?.transferCcy,
              // "rmtr_account_no:": viewMoreData?.rmtrAccountNo,
              // "rmtr_account_ifsc:": viewMoreData?.rmtrAccountIfsc,
              // "rmtr_account_type:": viewMoreData?.rmtrAccountType,
              "description:": viewMoreData?.description,
            }}
            closeModal={() => setShowViewMoreModal(false)}
          />
        </CustomModal1>
      )}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    seconds: state.scheduleJobReducer.seconds,
  };
};

export default connect(mapStateToProps)(FundTransfer);
